<template>
  <div class="menu-box">
    <div class="menu-bg" @click="closeMenu"></div>
    <div class="menu-content">
      <div class="menu-item" v-for="(menuItem, index) in menuData" :key="index">
        <span class="menu-item-title" @click="jumpScene(menuItem, index)"
          :class="{ active: sceneIndex.first == menuItem.active, hasChild: menuItem.children }">
          <!--          <i class="icon" :class="`icon-${menuItem.icon}`"></i>-->
          {{ menuItem.lable }}</span>
        <ul class="menu-item-children" v-if="index == 0 && activeMenu == index">
          <li class="menu-item-child" v-for="(menuChild, childIndex) in menuItem.children" :key="childIndex" :class="{
            active:
              sceneIndex.first == menuItem.active &&
              sceneIndex.second == menuChild.active,
          }" @click="jumpScene(menuChild)">
            <p class="menu-item-label">{{ menuChild.title }}</p>
            <p class="menu-item-value">{{ menuChild.lable }}</p>
          </li>
        </ul>
        <ul class="menu-child-ul2" v-if="index == 1 && activeMenu == index">
          <li v-for="(childItem, childIndex) in menuItem.children" :key="childIndex" class="menu-child-col">
            <span class="menu-child-li2" :class="{
              active:
                sceneIndex.first == menuItem.active &&
                sceneIndex.second == secChildItem.active,
            }" @click="jumpScene(secChildItem)" :title="secChildItem.lable"
              v-for="(secChildItem, secChildIndex) in childItem" :key="`${childIndex}-${secChildIndex}`">
              {{ secChildItem.lable }}
            </span>
          </li>

        </ul>
        <ul class="menu-child-ul3" v-if="index == 2 && activeMenu == index">
          <li v-for="(childItem, childIndex) in menuItem.children" :key="childIndex" class="menu-child-col">
            <span class="menu-child-li3" :class="{
              active:
                sceneIndex.first == menuItem.active &&
                sceneIndex.second == secChildItem.active,
            }" @click="jumpScene(secChildItem)" :title="secChildItem.lable"
              v-for="(secChildItem, secChildIndex) in childItem" :key="`${childIndex}-${secChildIndex}`">
              {{ secChildItem.lable }}
            </span>
          </li>

        </ul>
      </div>

    </div>
    <div class="close-icon" @click="closeMenu"></div>
  </div>
</template>

<script>
export default {
  props: {
    krpano: "",
    sceneName: "",
  },
  data() {
    return {
      menuData: [
        {
          lable: "序厅",
          index: "",
          disableClick: true,
          active: 0,
          // icon: "huangguan"
          children: [
            {
              lable: "第一单元\u3000序言",
              index: "0_1_1",
              active: "1",
            },
            {
              lable: "第二单元\u3000掌舵领航\u3000举旗定向",
              index: "0_2_1",
              active: "2",
            },
            {
              lable: "第三单元\u3000深耕笃行\u3000关怀备至",
              index: "0_3_1",
              active: "3",
            },
            {
              lable: "第四单元\u3000立柱架梁\u3000夯基垒台",
              index: "0_4_1",
              active: "4",
            },
            {
              lable: "第五单元\u3000纲举目张\u3000凝心聚力",
              index: "0_5_1",
              active: "5",
            },
            {
              lable: "第六单元\u3000品质生活\u3000美好共融",
              index: "0_6_1",
              active: "6",
            },
            {
              lable: "第七单元\u3000蓄势赋能\u3000助推腾飞",
              index: "0_7_1",
              active: "7",
            },
            {
              lable: "第八单元\u3000逐梦寰宇\u3000星海宫阙",
              index: "0_8_1",
              active: "8",
            }
          ]
        },
        {
          lable: "央企展区",
          index: "",
          disableClick: true,
          active: "1",
          // icon: "circle",
          children: [
            [
              {
                lable: "中核集团",
                index: "1_1_1",
                active: "1",
              },
              {
                lable: "航天科技",
                index: "1_2_1",
                active: "2",
              },
              {
                lable: "航天科工",
                index: "1_3_1",
                active: "3",
              },
              {
                lable: "航空工业集团",
                index: "1_4_1",
                active: "4",
              },
            ], [
              {
                lable: "中国船舶",
                index: "1_5_1",
                active: "5",
              },
              {
                lable: "兵器装备集团",
                index: "1_6_1",
                active: "6",
              },
              {
                lable: "中国石油",
                index: "1_7_1",
                active: "7",
              },
              {
                lable: "中国石化",
                index: "1_8_1",
                active: "8",
              },
            ], [
              {
                lable: "国家电网",
                index: "1_9_1",
                active: "9",
              },
              {
                lable: "南方电网",
                index: "1_10_1",
                active: "10",
              },
              {
                lable: "国家电投",
                index: "1_11_1",
                active: "11",
              },
              {
                lable: "中国三峡集团",
                index: "1_12_1",
                active: "12",
              },
            ], [
              {
                lable: "国家能源集团",
                index: "1_13_1",
                active: "13",
              },
              {
                lable: "中国电信",
                index: "1_14_1",
                active: "14",
              },
              {
                lable: "中国联通",
                index: "1_15_1",
                active: "15",
              },
              {
                lable: "中国移动",
                index: "1_16_1",
                active: "16",
              },
            ], [
              {
                lable: "中国一汽",
                index: "1_17_1",
                active: "17",
              },
              {
                lable: "东风公司",
                index: "1_18_1",
                active: "18",
              },
              {
                lable: "国机集团",
                index: "1_19_1",
                active: "19",
              },
              {
                lable: "中国宝武",
                index: "1_20_1",
                active: "20",
              },
            ], [
              {
                lable: "中国远洋海运",
                index: "1_21_1",
                active: "21",
              },
              {
                lable: "中航集团",
                index: "1_22_1",
                active: "22",
              },
              {
                lable: "中国东航",
                index: "1_23_1",
                active: "23",
              },
              {
                lable: "南航集团",
                index: "1_24_1",
                active: "24",
              },
            ], [
              {
                lable: "中国中化",
                index: "1_25_1",
                active: "25",
              },
              {
                lable: "中粮集团",
                index: "1_26_1",
                active: "26",
              },
              {
                lable: "通用技术集团",
                index: "1_27_1",
                active: "27",
              },
              {
                lable: "中国建筑",
                index: "1_28_1",
                active: "28",
              },
            ], [
              {
                lable: "国投",
                index: "1_29_1",
                active: "29",
              },
              {
                lable: "中国旅游集团",
                index: "1_30_1",
                active: "30",
              },
              {
                lable: "中国商飞",
                index: "1_31_1",
                active: "31",
              },
              {
                lable: "中国中车集团",
                index: "1_32_1",
                active: "32",
              },
            ], [
              {
                lable: "中国中铁",
                index: "1_33_1",
                active: "33",
              },
              {
                lable: "中国铁建",
                index: "1_34_1",
                active: "34",
              },
              {
                lable: "中交集团",
                index: "1_35_1",
                active: "35",
              },
              {
                lable: "国药集团",
                index: "1_36_1",
                active: "36",
              },
            ], [
              {
                lable: "保利集团",
                index: "1_37_1",
                active: "37",
              },
              {
                lable: "中广核",
                index: "1_38_1",
                active: "38",
              },
            ]

          ],
        },
        {
          lable: "地方展区",
          index: "",
          disableClick: true,
          active: "2",
          // icon: "house",
          children: [
            [
              {
                lable: "北京",
                index: "2_1_1",
                active: "1",
              },
              {
                lable: "天津",
                index: "2_2_1",
                active: "2",
              },
              {
                lable: "河北",
                index: "2_3_1",
                active: "3",
              },
              {
                lable: "山西",
                index: "2_4_1",
                active: "4",
              },
              {
                lable: "内蒙古",
                index: "2_5_1",
                active: "5",
              },
              {
                lable: "辽宁",
                index: "2_6_1",
                active: "6",
              },
              {
                lable: "吉林",
                index: "2_7_1",
                active: "7",
              },
            ], [
              {
                lable: "黑龙江",
                index: "2_8_1",
                active: "8",
              },
              {
                lable: "上海",
                index: "2_9_1",
                active: "9",
              },
              {
                lable: "江苏",
                index: "2_10_1",
                active: "10",
              },
              {
                lable: "浙江",
                index: "2_11_1",
                active: "11",
              },
              {
                lable: "安徽",
                index: "2_12_1",
                active: "12",
              },
              {
                lable: "福建",
                index: "2_13_1",
                active: "13",
              },
              {
                lable: "江西",
                index: "2_14_1",
                active: "14",
              },

            ], [
              {
                lable: "山东",
                index: "2_15_1",
                active: "15",
              },
              {
                lable: "河南",
                index: "2_16_1",
                active: "16",
              },
              {
                lable: "湖北",
                index: "2_17_1",
                active: "17",
              },
              {
                lable: "湖南",
                index: "2_18_1",
                active: "18",
              },
              {
                lable: "广东",
                index: "2_19_1",
                active: "19",
              },
              {
                lable: "广西",
                index: "2_20_1",
                active: "20",
              },
              {
                lable: "海南",
                index: "2_21_1",
                active: "21",
              },


            ], [
              {
                lable: "重庆",
                index: "2_22_1",
                active: "22",
              },
              {
                lable: "四川",
                index: "2_23_1",
                active: "23",
              },
              {
                lable: "贵州",
                index: "2_24_1",
                active: "24",
              },
              {
                lable: "云南",
                index: "2_25_1",
                active: "25",
              },
              {
                lable: "西藏",
                index: "2_26_1",
                active: "26",
              },
              {
                lable: "陕西",
                index: "2_27_1",
                active: "27",
              },
              {
                lable: "甘肃",
                index: "2_28_1",
                active: "28",
              },


            ], [
              {
                lable: "青海",
                index: "2_29_1",
                active: "29",
              },
              {
                lable: "宁夏",
                index: "2_30_1",
                active: "30",
              },
              {
                lable: "新疆",
                index: "2_31_1",
                active: "31",
              },
              {
                lable: "兵团",
                index: "2_32_1",
                active: "32",
              },
              {
                lable: "深圳",
                index: "2_33_1",
                active: "33",
              },
              {
                lable: "青岛",
                index: "2_34_1",
                active: "34",
              },
              {
                lable: "宁波",
                index: "2_35_1",
                active: "35",
              },

            ], [
              {
                lable: "大连",
                index: "2_36_1",
                active: "36",
              },
              {
                lable: "厦门",
                index: "2_37_1",
                active: "37",
              },
            ]

          ],
        },
        {
          lable: "创新100+",
          index: "",
          active: "3",
          disableClick: true,
          handleEmit: "openCX"
          // icon: "future"
        },
        {
          lable: "中国品牌消费节",
          index: "",
          active: "4",
          isLink: true,
          disableClick: true,
          href: "https://gongyi.cctv.com/special/ppr2023xfj/index.shtml",
          // icon: "future"
        },
      ],
      activeMenu: "",
    };
  },
  computed: {
    sceneIndex() {

      if (this.sceneName) {
        var nowSceneName = this.sceneName.split("_");
        let first =  nowSceneName[1];
        let second = nowSceneName[2]
        this.activeMenu = first;
        return {
          first,

          second
        };
      } else {
        return {
          first: 0,
          second: "",
        };
      }
    },
  },
  methods: {
    choseMenu(index) {
      this.activeMenu = index;
    },
    jumpScene(scene, index) {
      if (!scene.disableClick) {
        this.krpano.call(
          "loadscene(" +
          `scene_${scene.index}` +
          ",null, MERGE, OPENBLEND(1.0, -0.5, 0.3, 0.8, linear));"
        );
        setTimeout(() => {
          this.closeMenu();
        }, 500);
      } else {

        if (scene.isLink) {
          window.open(scene.href, "_blank");
        }
        if (scene.handleEmit) {
          this.closeMenu();
          this.$emit(scene.handleEmit)
        }
      }
      this.activeMenu = index;
    },
    closeMenu() {
      this.$emit("closeMenu");
    },
  },
  mounted() { },
  created() { },
};
</script>

<style lang="scss" scoped>
@mixin background-com {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.menu-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;

  .menu-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .menu-content {
    width: 100%;
    height: 15.5rem;
    background-color: rgba($color: #000000, $alpha: 0.86);
    border-radius: 0.52rem;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 0.53rem 0;
    overflow-y: auto;

    .menu-item {
      width: 100%;
      min-height: 0.85rem;
      line-height: 0.85rem;
      font-size: 0.32rem;
      font-weight: 500;
      color: #ffffff;
      text-align: left;

      .menu-item-title {
        width: calc(100% - 1.66rem);
        margin: 0 auto;
        display: block;
        position: relative;

        border-bottom: 2px solid rgba(126, 126, 126, 0.8);

        &.hasChild::after {
          content: "";
          width: 0.14rem;
          height: 0.14rem;
          border-radius: 50%;
          background-color: #ffffff;
          vertical-align: middle;
          display: inline-block;
          position: absolute;
          right: 0.03rem;
          top: 50%;
          margin-top: -0.07rem;
        }

        .icon {
          width: 0.34rem;
          height: 0.32rem;
          @include background-com();
          display: inline-block;
          margin-right: 0.17rem;

          &.icon-building {
            background-image: url("../../assets/img/icon-building.png");
          }

          &.icon-huangguan {
            background-image: url("../../assets/img/icon-huangguan.png");
          }

          &.icon-circle {
            background-image: url("../../assets/img/icon-circle.png");
          }

          &.icon-house {
            background-image: url("../../assets/img/icon-house.png");
          }

          &.icon-future {
            background-image: url("../../assets/img/icon-future.png");
          }

          &.icon-hudong {
            background-image: url("../../assets/img/icon-hudong.png");
          }
        }

        &.active {
          color: #DF8903;

          .icon {

            &.icon-building {
              background-image: url("../../assets/img/icon-building-active.png");
            }

            &.icon-huangguan {
              background-image: url("../../assets/img/icon-huangguan-active.png");
            }

            &.icon-circle {
              background-image: url("../../assets/img/icon-circle-active.png");
            }

            &.icon-house {
              background-image: url("../../assets/img/icon-house-active.png");
            }

            &.icon-future {
              background-image: url("../../assets/img/icon-future-active.png");
            }

            &.icon-hudong {
              background-image: url("../../assets/img/icon-hudong-active.png");
            }
          }

          &.hasChild::after {
            background-color: #DF8903;
          }
        }
      }

      &:last-child {
        .menu-item-title {
          border-bottom: none;
        }
      }

      .menu-item-children {
        width: 100%;
        padding: 0.5rem 1rem;
        background-color: rgba($color: #8a0f11, $alpha: 0.6);

        .menu-item-child {
          font-size: 0.26rem;
          color: #ffffff;
          text-align: left;

          line-height: 0.68rem;

          margin: 0 auto;
          font-weight: 500;
          display: flex;



          &.active {
            color: #DF8903;


          }

          .menu-item-label {
            // width: 2rem;
            flex-shrink: 0;
          }

          .menu-item-value {
            flex: 1;
          }
        }
      }

      .menu-child-ul2 {
        width: 100%;
        padding: 0.5rem 1rem;
        background-color: rgba($color: #8a0f11, $alpha: 0.6);

        .menu-child-col {
          font-size: 0.26rem;
          color: #ffffff;
          text-align: left;
          line-height: 0.66rem;
          height: 0.66rem;
          margin: 0 auto;
          font-weight: 500;
          display: flex;

          border-bottom: 2px solid rgba(154, 154, 154, 0.8);

          .menu-child-li2 {
            font-size: 0.26rem;
            font-weight: 400;
            width: 25%;

            &::after {
              content: '';
              display: inline-block;
              padding-left: 100%;
              margin-left: 100%;
            }

            &.active {
              color: #DF8903;
            }
          }
        }
      }

      .menu-child-ul3 {
        width: 100%;
        padding: 0.24rem 0.96rem;
        background-color: rgba($color: #8a0f11, $alpha: 0.6);

        .menu-child-col {
          font-size: 0.26rem;
          color: #ffffff;
          text-align: left;
          line-height: 0.66rem;
          height: 0.66rem;
          margin: 0 auto;
          font-weight: 500;
          display: flex;

          border-bottom: 2px solid rgba(154, 154, 154, 0.8);

          .menu-child-li3 {
            font-size: 0.26rem;
            font-weight: 400;
            width: 14.285%;

            &::after {
              content: '';
              display: inline-block;
              padding-left: 100%;
              margin-left: 100%;
            }

            &.active {
              color: #DF8903;
            }
          }
        }
      }
    }


  }

  .close-icon {
    width: 0.98rem;
    height: 0.98rem;
    background-image: url("../../assets/img/answer/answer-close-btn.png");
    @include background-com();
    position: absolute;
    left: 50%;
    margin-left: -0.49rem;
    bottom: 1.5rem;
  }
}
</style>